module.exports = __webpack_public_path__ + "static/media/header_logo6.638ac466.png";